import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initAmplitude } from './app/shared/services/amplitude.config';

if (environment.name === 'production' || environment.name === 'homolog') {
  enableProdMode();
}

initAmplitude();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
